export default function getFilters({activeReservationType, activeAmenities}) {
    const allFilters = [
        ...activeAmenities,
        ...(activeReservationType !== 'all' ? [activeReservationType] : []),
    ];

    return allFilters.map(filter => {
        return {value: filter};
    });
}
